<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import appConfig from "@/app.config";
import blogSvc from "@/services/blog";
import provinceSvc from "@/services/province";
import categorySvc from "@/services/category";
import { toast } from "vue3-toastify";

/**
 * Customers component
 */
export default {
  page: {
    title: "Event List",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Event List",
      role:
        localStorage.getItem("userInfo") !== null
          ? JSON.parse(localStorage.getItem("userInfo")).role
          : "user",
      items: [
        {
          text: "Event",
          href: "#",
        },
        {
          text: "Event List",
          active: true,
        },
      ],
      columns: [
        {
          label: "",
          field: "lineNumber",
          sortable: false,
        },
        {
          field: "uuid",
          hidden: true,
        },
        {
          field: "statusText",
          hidden: true,
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Type",
          field: "type",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Type",
            filterDropdownItems: [
              { value: "event", text: "Event" },
              { value: "news", text: "News" },
            ],
            trigger: "enter",
          },
        },
        // {
        //   label: "Language",
        //   field: "isEn",
        // },
        {
          label: "Language",
          field: "language",
        },
        {
          label: "Status",
          field: "statusCode",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Status",
            filterDropdownItems: [
              { value: "created", text: "Draft" },
              { value: "pending_verify", text: "Pending Verify" },
              { value: "publish", text: "Publish" },
              { value: "editing", text: "Editing" },
              { value: "rejected", text: "Rejected" },
            ],
            trigger: "enter",
          },
        },
        {
          label: "Highlight",
          field: "isHighlight",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
        {
          label: "Created Date",
          field: "createdAt",
          type: "Date",
        },
        {
          label: "Last Updated",
          field: "updatedAt",
          type: "Date",
        },
        {
          label: "Status",
          field: "isActive",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Status",
            filterDropdownItems: [
              { value: "true", text: "On" },
              { value: "false", text: "Off" },
            ],
            trigger: "enter",
          },
          sortable: false,
        },
        {
          label: "Source By",
          field: "tatApiUpdatedAt",
        },
        {
          field: "aptApiUpdatedAt",
          hidden: true,
        },
        {
          field: "cloneStatus",
          hidden: true,
        },
        {
          label: "Action",
          field: "button",
          html: true,
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
          width: "200px",
        },
      ],
      rows: [],
      totalRows: 0,
      eventHighlightCount: 0,
      newsHighlightCount: 0,
      table: {
        page: 1,
        perPage: 30,
        type: "",
        status: "",
        isActive: "",
        sort: {
          by: "",
          type: "",
        },
        search: "",
        provinceCode: "",
        categoryUUID: "",
        startDate: "",
        endDate: "",
      },
      typingTimer: null,
      provinces: [],
      categories: [],
    };
  },
  mounted() {
    this.get();
    this.loadProvinces();
    this.loadCategories();
  },
  methods: {
    onPageChange(params) {
      this.table.page = params.currentPage;
      this.table.perPage = params.currentPerPage;
      this.get();
    },
    onSortChange(params) {
      params.forEach((v) => {
        this.table.sort.by = v.type !== "none" ? v.field : "";
        this.table.sort.type = v.type !== "none" ? v.type : "";
      });
      this.table.page = 1;
      this.get();
    },
    onColumnFilter(params) {
      for (const [field, value] of Object.entries(params.columnFilters)) {
        if (field === "statusCode") {
          this.table.status = value;
        }
        if (field === "type") {
          this.table.type = value;
        }
        if (field === "isActive") {
          this.table.isActive = value;
        }
      }
      this.table.page = 1;
      this.get();
    },
    handleSearch() {
      this.table.page = 1;
      this.get();
    },
    loadProvinces() {
      provinceSvc.getAllDropdown().then((resp) => {
        if (resp.data.data) {
          this.provinces = resp.data.data;
        }
      });
    },
    loadCategories() {
      categorySvc.getAllDropdown().then((resp) => {
        if (resp.data.data) {
          this.categories = resp.data.data;
        }
      });
    },
    openDatePicker(ref) {
      this.$refs[ref].click();
    },
    get() {
      blogSvc
        .getAll(
          this.table.page,
          this.table.perPage,
          this.table.search,
          this.table.type,
          this.table.status,
          this.table.isActive,
          this.table.sort.by,
          this.table.sort.type,
          this.table.categoryUUID,
          this.table.provinceCode,
          this.table.startDate,
          this.table.endDate
        )
        .then(async (resp) => {
          if (resp.data.data.blog === null) {
            this.rows = [];
            this.totalRows = resp.data.data.total;
            return;
          }

          this.rows = resp.data.data.blog;
          this.totalRows = resp.data.data.total;
        })
        .finally(() => {
          this.countHighlight();
        });
    },
    checkUpdateHighlight(type) {
      if (type === "event") {
        return this.eventHighlightCount >= 12;
      }
      if (type === "news") {
        return this.newsHighlightCount >= 2;
      }
    },
    countHighlight() {
      blogSvc.getBlogHighlight().then((resp) => {
        if (resp.data.data === null) {
          return true;
        }

        let eventCount = 0;
        let newsCount = 0;
        resp.data.data.forEach((v) => {
          if (v.type === "event") {
            eventCount++;
          }
          if (v.type === "news") {
            newsCount++;
          }
        });

        this.eventHighlightCount = eventCount;
        this.newsHighlightCount = newsCount;
      });
    },
    updateBlogHighlight(uuid) {
      blogSvc
        .updateBlogHighlight(uuid)
        .then((resp) => {
          if (resp.status === 200) {
            toast.success("Update Highlight Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          } else {
            toast.error("Update Highlight Failed", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.get();
        });
    },
    deleteBlog(uuid) {
      blogSvc
        .deleteBlog(uuid)
        .then((resp) => {
          if (resp.status === 200) {
            toast.success("Change Status Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          } else {
            toast.error("Change Status Failed", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.get();
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-sm-end">
                  <b-button
                    class="btn btn-success btn-rounded mb-2 me-2"
                    router-link
                    :to="`manage`"
                  >
                    <i class="mdi mdi-plus me-1"></i> New Event
                  </b-button>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <div class="vgt-global-search vgt-clearfix">
                <div class="row mb-3 align-items-end g-2">
                  <div class="col-lg-2">
                    <label for="search" class="form-label">ค้นหา</label>
                    <input
                      id="search"
                      type="text"
                      v-model="table.search"
                      class="form-control"
                      placeholder="ค้นหา..."
                    />
                  </div>
                  <div class="col-lg-2">
                    <label for="province" class="form-label">จังหวัด</label>
                    <select
                      id="province"
                      v-model="table.provinceCode"
                      class="form-select"
                    >
                      <option value="">-- เลือกจังหวัด --</option>
                      <option v-for="prov in provinces" :key="prov.value" :value="prov.value">
                        {{ prov.text }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label for="category" class="form-label">ความสนใจ</label>
                    <select
                      id="category"
                      v-model="table.categoryUUID"
                      class="form-select"
                    >
                      <option value="">-- เลือกหมวดหมู่ --</option>
                      <option v-for="cat in categories" :key="cat.value" :value="cat.value">
                        {{ cat.text }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label">ช่วงกิจกรรม</label>
                    <div class="d-flex gap-2">
                      <input
                        ref="startDateInput"
                        type="date"
                        v-model="table.startDate"
                        class="form-control"
                        placeholder="วันเริ่มต้น"
                        @click="openDatePicker('startDateInput')"
                      />
                      <input
                        ref="endDateInput"
                        type="date"
                        v-model="table.endDate"
                        class="form-control"
                        placeholder="วันสิ้นสุด"
                        @click="openDatePicker('endDateInput')"
                      />
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <b-button
                      class="btn btn-primary w-100"
                      @click="handleSearch"
                    >
                      <i class="mdi mdi-magnify me-1"></i> ค้นหา
                    </b-button>
                  </div>
                </div>
              </div>
              <vue-good-table
                :pagination-options="{
                  enabled: true,
                  perPage: 30,
                  mode: 'records',
                  dropdownAllowAll: false,
                  perPageDropdown: [30, 40, 50, 100],
                }"
                v-on:per-page-change="onPageChange"
                v-on:page-change="onPageChange"
                v-on:search="onSearch"
                v-on:sort-change="onSortChange"
                v-on:column-filter="onColumnFilter"
                styleClass="tableOne vgt-table striped"
                :columns="columns"
                :rows="rows"
                :totalRows="totalRows"
              >
                <template #table-row="props">
                  <span v-if="props.column.field == 'lineNumber'">
                    <th class="line-numbers">
                      {{ (table.page - 1) * table.perPage + props.index + 1 }}
                    </th>
                  </span>
                  <span v-else-if="props.column.field == 'tatApiUpdatedAt'">
                    <b-badge
                      v-if="['already'].includes(props.row.cloneStatus)"
                      variant="success"
                      >{{ props.row.cloneStatus && props.row.tatApiUpdatedAt ? "TAT" : props.row.cloneStatus && props.row.aptApiUpdatedAt ? "APT" : "" }}</b-badge
                    >
                    <div v-if="['warning'].includes(props.row.cloneStatus)">
                      <b-badge variant="success">{{ props.row.cloneStatus && props.row.tatApiUpdatedAt ? "TAT" : props.row.cloneStatus && props.row.aptApiUpdatedAt ? "APT" : "" }}</b-badge>
                      <div>
                        <i class="bx bx bxs-error-circle text-danger"
                          >ข้อมูลมีการเปลี่ยนแปลง</i
                        >
                      </div>
                    </div>
                  </span>
                  <span v-else-if="props.column.field == 'aptApiUpdatedAt'">
                    <b-badge
                      v-if="['already'].includes(props.row.cloneStatus)"
                      variant="success"
                      >APT</b-badge
                    >
                    <div v-if="['warning'].includes(props.row.cloneStatus)">
                      <b-badge variant="success">APT</b-badge>
                      <div>
                        <i class="bx bx bxs-error-circle text-danger"
                          >ข้อมูลมีการเปลี่ยนแปลง</i
                        >
                      </div>
                    </div>
                  </span>
                  <span v-else-if="props.column.field == 'button'">
                    <b-button
                      size="sm"
                      variant="light"
                      class="me-2"
                      router-link
                      :to="`manage?duplicate=${props.formattedRow.uuid}`"
                    >
                      <i class="mdi mdi-content-copy font-size-16 align-middle"></i>
                      Duplicate
                    </b-button>
                    <b-button
                      v-if="props.formattedRow.statusCode === 'pending_verify'"
                      size="sm"
                      :variant="role !== 'user' ? 'warning' : 'primary'"
                      router-link
                      :to="`manage?uuid=${props.formattedRow.uuid}`"
                    >
                      <i
                        :class="`mdi mdi-${
                          role !== 'user' ? 'file-check-outline' : 'eye'
                        } font-size-16 align-middle`"
                      ></i>
                      {{ role !== "user" ? "Verify" : "View" }}
                    </b-button>
                    <b-button
                      v-else-if="
                        ['publish', 'unpublish', 'editing'].includes(
                          props.formattedRow.statusCode
                        )
                      "
                      size="sm"
                      variant="primary"
                      router-link
                      :to="`manage?uuid=${props.formattedRow.uuid}`"
                    >
                      <i class="mdi mdi-eye font-size-16 align-middle"></i>
                      View
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="success"
                      router-link
                      :to="`manage?uuid=${props.formattedRow.uuid}`"
                    >
                      <i class="mdi mdi-pencil font-size-16 align-middle"></i>
                      Edit
                    </b-button>
                  </span>
                  <span v-else-if="props.column.field == 'statusCode'">
                    <b-badge
                      v-if="
                        [
                          'created',
                          'pending_verify',
                          'editing',
                          'draft',
                          'updated',
                        ].includes(props.row.statusCode)
                      "
                      variant="warning"
                      >{{ props.formattedRow["statusText"] }}</b-badge
                    >
                    <b-badge
                      v-else-if="
                        ['rejected', 'unpublish'].includes(props.row.statusCode)
                      "
                      variant="danger"
                      >{{ props.formattedRow["statusText"] }}</b-badge
                    >
                    <b-badge
                      v-else-if="
                        ['approved', 'publish', 'publish_draft'].includes(
                          props.row.statusCode
                        )
                      "
                      variant="success"
                      >{{ props.formattedRow["statusText"] }}</b-badge
                    >
                    <b-badge v-else>-</b-badge>
                  </span>
                  <span v-else-if="props.column.field == 'isHighlight'">
                    <b-form-checkbox
                      v-model="props.formattedRow.isHighlight"
                      name="check-button"
                      switch
                      @change="updateBlogHighlight(props.formattedRow.uuid)"
                      :disabled="checkUpdateHighlight(props.formattedRow.type)"
                    >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-success"
                        v-if="props.formattedRow.isHighlight"
                        >Yes</span
                      >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-warning"
                        v-else
                        >No</span
                      >
                    </b-form-checkbox>
                  </span>
                  <span v-else-if="props.column.field == 'isActive'">
                    <b-form-checkbox
                      v-model="props.formattedRow.isActive"
                      name="check-button"
                      switch
                      @change="deleteBlog(props.formattedRow.uuid)"
                    >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-success"
                        v-if="props.formattedRow.isActive"
                        >On</span
                      >
                      <span
                        class="badge rounded-pill font-size-12 badge-soft-warning"
                        v-else
                        >Off</span
                      >
                    </b-form-checkbox>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
th.line-numbers {
  border-bottom: none !important;
}

input[type="date"] {
  cursor: pointer;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
</style>
